
export default {
    accountSetting: 'ตั้งค่าบัญชี',
    cancel: 'ยกเลิก',
    save: 'บันทึก',
    profile: 'ประวัติ',
    edit: 'แก้ไข',
    employeeID: 'รหัสพนักงาน',
    phoneNumber: 'เบอร์โทรศัพท์',
    name: 'ชื่อ',
    surname: 'นามสกุล',
    username: 'ชื่อผู้ใช้งาน',
    emailAddress: 'อีเมล',
    resetPassword: 'เปลี่ยนรหัสผ่าน',
    oldPassword: 'รหัสผ่านเดิม',
    enterYourOldPassword: 'ระบุรหัสผ่านเดิม',
    newPassword: 'สร้างรหัสผ่าน',
    enterYourNewPassword: 'ระบุระบุรหัสผ่านใหม่',
    confirmPassword: 'ยืนยันรหัสผ่าน',
    confirmYourNewPassword: 'ระบุรหัสผ่านอีกครั้ง',
    fieldRequest: 'กรุณากรอกข้อมูล',
    updateAccountInformation: 'แก้ไขข้อมูลบัญชี',
    successfully: 'สำเร็จ',
    emailRequired: 'ระบุอีเมล',
    emailFormatMustBeValid: 'รูปแบบอีเมลไม่ถูกต้อง',
    currentPasswordRequired: 'ระบุรหัสผ่านเดิม',
    newPasswordRequired: 'ระบุรหัสผ่านใหม่',
    confirmPasswordRequired: 'ระบุรหัสผ่านอีกครั้ง',
    confirmPasswordShouldBeSame: 'ยืนยันรหัสไม่ตรงกัน',
    enterName: 'ระบุชื่อ',
    enterSurame: 'ระบุนามสกุล',
    enterPhonenumber: 'ระบุนามสกุล'
}
